import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Fornecedor',
  path: '/gestao/fornecedor/:tipofornecedor?',
  name: 'fornecedor',
  component: () => import('@/views/gestao/fornecedor/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.FORNECEDORNOVO_MENU_1900400199],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Fornecedor',
  path: '/gestao/fornecedor/cadastro/:id?/:tipofornecedor?',
  parent: 'fornecedor',
  name: 'fornecedor_create',
  component: () => import('@/views/gestao/fornecedor/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.FORNECEDORNOVO_MENU_1900400199],
  },
  goesToMenu: true,
 },
]
